import {
  formatDot,
  switchDotsAndCommas,
  numberWithCommas,
} from "../../util/utilFunction";

export const fmt = (n) => formatDot(switchDotsAndCommas(numberWithCommas(n)));

export const LEGEND = [
  ["belum", "PO Belum Kirim"],
  ["majubelum", "PO Maju Belum Kirim"],
  ["mundurbelum", "PO Mundur Belum Kirim"],
  ["awal", "PO Awal"],
  ["sudah", "PO Sudah Kirim"],
  ["majusudah", "PO Maju Sudah Kirim"],
  ["mundursudah", "PO Mundur Sudah Kirim"],
  ["batal", "Batal"],
];

export const TABS = [
  ["Input", "Input PO"],
  ["Memo", "Memo Kirim"],
  ["SuratJalan", "Surat Jalan"],
  ["SJManual", "SJ Manual"],
  ["Riwayat", "Riwayat Cancellation"],
];
